import Mixpanel from 'mixpanel-browser'
import { get as _get } from 'lodash'

import { generateTypes, getCollectionActionHandlers } from 'helpers/actions'
import moment from 'helpers/moment'

const modelName = 'order'

export function get (date = 'today') {
  return {
    types: generateTypes(`${modelName}s`),
    api: api => api(`${modelName}s?date=${date}`),
    date
  }
}

// this allows for an ARRAY POST, being that we're in a collection
export function postMultiple (data) {
  return {
    types: generateTypes(`create_multiple_${modelName}s`),
    data,
    create_temp: false,
    api: api => api(`${modelName}s`, { method: 'post', body: data }),
    onApiSuccess: (nextAction) => {
      nextAction.notify = { type: 'success', message: 'Your order has been sent to TwoXSea!' }

      data.forEach(order => {
        Mixpanel.track('Sent to TwoXSea', {
          date: _get(order, 'date'),
          customer_name: _get(order, 'customer.name'),
          route_name: _get(order, 'customer.name'),
          product_name: _get(order, 'product.name'),
          qty: _get(order, 'qty'),
          uom_name: _get(order, 'uom.name'),
          option_name: _get(order, 'option.name'),
          notes: _get(order, 'notes')
        })
      })

      return nextAction
    }
  }
}

export function markPrinted (orders) {
  let data = orders.map(order => ({
    id: order.id,
    printed_at: moment(new Date()).format()
  }))

  // this is a PUT multiple..  (no id constraint)
  return {
    types: generateTypes(`put_multiple_${modelName}s`),
    data,
    api: api => api(`${modelName}s`, { method: 'put', body: data })
  }
}

export function markNotPrinted (orders) {
  let data = orders.map(order => ({
    id: order.id,
    printed_at: null
  }))

  // this is a PUT multiple..  (no id constraint)
  return {
    types: generateTypes(`put_multiple_${modelName}s`),
    data,
    api: api => api(`${modelName}s`, { method: 'put', body: data })
  }
}

export const actions = {
  get,
  postMultiple,
  markPrinted,
  markNotPrinted
}

// Action Handlers
const initialState = []
function getTempId (model) {
  return `${moment(model.date).startOf('day').valueOf()}:${model.customer_id}:${model.route_id}:${model.product_id}:${model.qty}`
}
const ACTION_HANDLERS = getCollectionActionHandlers({ modelName, getTempId })

export default function (state = initialState, action) {
  let handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Orders/modules/orders.js